import dynamic from "next/dynamic";

export const DynamicContent066 = dynamic(() => import("./Content066"), {
  suspense: true,
});
